const TimeLineLoader = () => (
  <div className="space-y-4 bg-white p-6">
    {[1, 2, 3].map((i) => (
      <div key={i} className="flex items-start space-x-3">
        <div className="size-8 animate-pulse rounded-full bg-gray-200" />
        <div className="flex-1 space-y-2">
          <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
          <div className="h-3 w-1/2 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    ))}
  </div>
);

export default TimeLineLoader;
